/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosAddressInfo = {
    ADT: AptosAddressInfo.ADT;
    ADDR: string;
    NN: string;
    BL: string;
    BLP: string;
};

export namespace AptosAddressInfo {

    export enum ADT {
        EOA = 'EOA',
        CA = 'CA',
        OBJECT = 'OBJECT',
    }


}

